<template>
  <div class="icon-group">
    <sc-placeholder name="jss-icon-group" :rendering="rendering" />
  </div>
</template>

<script>
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Icon-Group',
  components: {
    ScPlaceholder: Placeholder
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    },
    rendering: {
      type: Object
    }
  }
};
</script>
<style lang="scss" scoped>
.icon-group {
  display: flex;
  flex-wrap: wrap;
  margin: 4rem 0;

  // Child Elements
  &:deep() {
    .icon-group-item {
      text-align: center;
      padding: 2rem;
      width: calc(100% / 2);

      @include tablet-up {
        width: calc(100% / 3);
      }

      @include desktop-up {
        width: calc(100% / 4);
      }

      span {
        display: block;
        font-size: 1.6rem !important;
        line-height: 2rem !important;
        font-weight: 600;
        margin: 0 !important;
        color: $dark-blue;

        &.topMargin {
          margin-top: 2rem;
        }
      }

      a {
        display: inline-block;

        img,
        span {
          position: relative;
          z-index: -1;
        }
      }
    }
  }
}
</style>
